import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import moment from "moment";
import { ConversionUtils } from "../../../../domain/conversion-utils";
import { Subscription } from "rxjs";
import { RouteSecEventType } from "../../../../domain/route-sec-event-type";
import { UI } from "../../../../services/ui.service";
import { SecEventsService } from "../sec-events.service";
import { SecEventCategory } from "../../../../domain/sec-event-category";
import { Show } from "../../../../domain/show";

@Component({
  selector: "evrideo-calendar-expandable-floating-media-event",
  templateUrl: "./calendar-expandable-floating-media-event.component.html",
  styleUrls: ["./calendar-expandable-floating-media-event.component.scss"],
})
export class CalendarExpandableFloatingMediaEventComponent
  implements OnInit, OnDestroy
{
  @Input() floatingMediaData;

  @Input() formatTime: (time: moment.Moment) => string;
  @Input() formatDuration: (duration: moment.Duration) => string;
  @Input() toggleSecEvent: (show: Show, eventId: string) => void;

  @Input() show: Show;

  properties;

  onEventToggleSubscription: Subscription;
  timeChangeSubscription: Subscription;

  constructor(
    private ui: UI,
    private secEventsApi: SecEventsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.properties = this.floatingMediaData.properties;

    this.onEventToggleSubscription = this.secEventsApi.onEventToggle.subscribe(
      (data) => {
        if (
          data.showId === this.show.id &&
          data.id === this.floatingMediaData.properties.id &&
          data.offset === this.floatingMediaData.properties.offset
        ) {
          this.updateEventToggleUI();
        }
      },
    );

    this.timeChangeSubscription = this.secEventsApi.onTimeChange.subscribe(
      ({
        showId,
        identifier,
        originalOffset,
        newStartTime,
        newOffset,
        newEndTime,
        newDuration,
        eventType,
      }) => {
        if (
          eventType === SecEventCategory.FloatingMedia &&
          showId === this.show.id &&
          identifier === this.floatingMediaData.properties.id &&
          originalOffset === this.floatingMediaData.properties.offset
        ) {
          this.floatingMediaData.properties.startTime = newStartTime;
          this.floatingMediaData.properties.offset = newOffset;
          this.floatingMediaData.properties.duration = newDuration;
          this.floatingMediaData.properties.endTime = newEndTime;
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.timeChangeSubscription?.unsubscribe();
    this.onEventToggleSubscription?.unsubscribe();
  }

  updateEventToggleUI() {
    this.floatingMediaData.properties.enabled =
      !this.floatingMediaData.properties.enabled;
    this.changeDetectorRef.detectChanges();
  }

  async deleteEvent() {
    try {
      await this.secEventsApi.deleteEvent(
        SecEventCategory.FloatingMedia,
        this.show.id,
        this.properties.id,
        this.properties.offset,
      );
    } catch (e) {
      this.ui.notify(this.ui.EVENTS.ShowAlert, {
        title: "Error deleting event",
        message: e.message,
      });
    }
  }
}
